const getters = {
    submitFormStatus(state) {
        if ('status' in state.submitForm) {
            return state.submitForm['status'];
        } 
        return false;
    },
    companyEmailApiError(state) {
        if ('company_email' in state.formErrors) {
            return 'Given e-post används redan i systemet.';
        } 
        return null;
    },
    companyWebpageApiError(state) {
        if ('company_webpage' in state.formErrors) {
            return 'Felaktigt format. Måste börja med https:// eller http://.';
        } 
        return null;
    },
}

export default getters;